import { BaseApi } from './base.api.js';

export class DpiaTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/dpia-template');
    }
}
